import { render } from "./VcnContent.vue?vue&type=template&id=764fb30a&scoped=true"
import script from "./VcnContent.vue?vue&type=script&lang=js"
export * from "./VcnContent.vue?vue&type=script&lang=js"

import "./VcnContent.vue?vue&type=style&index=0&id=764fb30a&scoped=true&lang=css"
import "./VcnContent.vue?vue&type=style&index=1&id=764fb30a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764fb30a"]])

export default __exports__